<template lang='pug'>
//- binder-Page
div(:class='$style[`cc-binder`]')
  div(v-if='showLoading' :class='$style[`cc-binder-wrap`]')
    div(:class='$style[`cc-binder-loader`]')
      IconLoading(:size='60' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-binder-wrap`]')
    div(v-if='bindError && bindCodeInvalid' :class='$style[`cc-binder-block`]')
      div(:class='$style[`cc-binder-content`]')
        div(:class='$style[`cc-binder-content-title`]')
          span.font-bold.no-wrap 錯誤，邀請碼已失效

        ul(:class='$style[`cc-binder-content-info`]')
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-tutorial`]') 1. 僅限使用一次，可能您已使用過
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-tutorial`]') 2. 聯繫客服 (service@cancell.tw)

        div(:class='$style[`cc-binder-content-control`]')
          router-link.btn-black-extra(
            title=' 問題回報'
            tabindex='0' aria-label=' 問題回報'
            :class='$style[`cc-binder-content-control-btn`]'
            to='feedback') 
            span(style='color: white')  問題回報

    div(v-else-if='bindError' :class='$style[`cc-binder-block`]')
      div(:class='$style[`cc-binder-content`]')
        div(:class='$style[`cc-binder-content-title`]')
          span.font-bold.no-wrap 發生錯誤! 請重試

        ul(:class='$style[`cc-binder-content-info`]')
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-tutorial`]') 1. 醫療照護單位資訊有誤
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-tutorial`]') 2. 重新掃QRcode
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-tutorial`]') 3. 聯繫客服 (service@cancell.tw)

        div(:class='$style[`cc-binder-content-control`]')
          router-link.btn-black-extra(
            title=' 問題回報'
            tabindex='0' aria-label=' 問題回報'
            :class='$style[`cc-binder-content-control-btn`]'
            to='feedback') 
            span(style='color: white')  問題回報

    div(v-else-if='needLogin' :class='$style[`cc-binder-block`]')
      div(:class='$style[`cc-binder-content`]')
        figure.graphic.graphic-bind_login(:class='$style[`cc-binder-graphic`]')

        div(:class='$style[`cc-binder-content-title`]')
          span.font-bold.no-wrap 請先登入會員
          span(:class='$style[`cc-binder-content-subtitle`]') 登入後請先建立病歷資料。提醒您，完成後需再次掃QRcode完成開通。

        div(:class='$style[`cc-binder-content-line`]')
          span(:class='$style[`cc-binder-content-login-title`]') 推薦使用 LINE 登入與註冊
          button(
            tabindex='0' aria-label='快速登入 / 註冊'
            :class='$style[`cc-content-line-login-btn`]'
            @click='handleClickLineAuthorize(`all`)')
            IconLine(:size='36')
            span 快速登入 / 註冊

        div(:class='$style[`cc-binder-content-control`]')
          button.btn-extra(
            title='其他登入方式'
            tabindex='0' aria-label='其他登入方式'
            :class='$style[`cc-binder-content-control-btn`]'
            @click='handleShowPopLogin') 其他登入方式
          //- span(:class='$style[`cc-binder-content-login-title`]') * 完成後，請再次掃QRcode開通
          
    div(v-else :class='$style[`cc-binder-block`]')
      div(:class='$style[`cc-binder-block-avatar`]')
        div(:class='$style[`cc-binder-block-profile`]')
          figure(v-if='loginProfile.thumbSrc !== `` && loginProfile.public' :class='$style[`cc-binder-block-photo`]')
            img(
              :src='avatarSrcLink(loginProfile.thumbSrc)'
              width='100%'
              height='100%')
          figure(v-else :class='$style[`cc-binder-block-photo`]')
            img(
              v-if='loginProfile.gender === `0`'
              :src='`${STATIC_URL}images/common/user/normal_male.webp`'
              width='100%'
              height='100%')
            img(
              v-else
              :src='`${STATIC_URL}images/common/user/normal_female.webp`'
              width='100%'
              height='100%')
          span.font-medium(:class='$style[`cc-binder-block-name`]') {{ loginProfile.firstName + loginProfile.lastName }}

        div(:class='$style[`cc-binder-block-tips`]') 即將配對

        div(:class='$style[`cc-binder-block-vendor`]')
          figure(v-if='vendorProfile.thumbSrc !== ``' :class='$style[`cc-binder-block-photo`]')
            img(
              :src='avatarSrcLink(vendorProfile.thumbSrc)'
              width='100%'
              height='100%')
          span.font-medium(:class='$style[`cc-binder-block-name`]') {{ vendorProfile.vendor }}

      div(v-if='createSideEffect' :class='$style[`cc-binder-content`]')
        div(:class='$style[`cc-binder-content-title`]')
          span.font-bold.no-wrap 請先建立病歷資料

        ul(:class='$style[`cc-binder-content-info`]')
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-tutorial`]') 1. 只需要填寫一次
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-tutorial`]') 2. 完成填寫後請再次掃QRcode
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-tutorial`]') 3. 完成開通

        div(:class='$style[`cc-binder-content-control`]')
          router-link.btn-extra(
            title='前往填寫'
            tabindex='0' aria-label='前往填寫'
            :class='$style[`cc-binder-content-control-btn`]'
            :to='`sideeffect/setup?b=${$route.query.b}`') 
            span 前往填寫


      div(v-else-if='!createSideEffect && bindActive' :class='$style[`cc-binder-content`]')
        div(:class='$style[`cc-binder-content-title`]')
          span.font-bold 目前已開通啟用中

        div(:class='$style[`cc-binder-content-active`]')
          svg(fill="none" viewBox="0 0 24 24" height="70" width="70")
            circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
            path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
        
        div(:class='$style[`cc-binder-content-control`]')
          router-link.btn-extra(
            title='前往使用'
            tabindex='0' aria-label='前往使用'
            :class='$style[`cc-binder-content-control-btn`]'
            to='/sideeffect/consult') 
            span 前往使用


      div(v-else-if='!createSideEffect && !bindActive' :class='$style[`cc-binder-content`]')
        div(:class='$style[`cc-binder-content-title`]')
          span.font-bold.no-wrap(v-if='bindType === `trail`') 加入臨床試驗計畫
          span.font-bold.no-wrap(v-else-if='bindType === `expense`') 自費照護方案
          span.font-bold.no-wrap(v-else-if='bindType === `redeem`') 加值照護服務
        
        //- 臨床試驗
        ul(v-if='bindType === `trail`' :class='$style[`cc-binder-content-info`]')
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') {{ '免費訂閱VIP會員(' + bindMonth + '個月)' }}

          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') 與「配對的醫療顧問」線上諮詢

          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') AI諮詢與健檢，副作用管理

          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') 學習所有抗癌衛教內容

        //- 兌換碼推薦
        ul(v-else-if='bindType === `redeem`' :class='$style[`cc-binder-content-info`]')
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') {{ '免費訂閱VIP會員(' + bindMonth + '個月)' }}

          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') 與「配對的醫療顧問」線上諮詢

          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') AI諮詢與健檢，副作用管理

          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') 學習所有抗癌衛教內容

        //- 自費訂閱
        ul(v-else-if='bindType === `expense`' :class='$style[`cc-binder-content-info`]')
          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') {{ '訂閱VIP會員(' + bindMonth + '個月)' }}

          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') 與「配對的醫療顧問」線上諮詢

          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') AI諮詢與健檢，副作用管理

          li(:class='$style[`cc-binder-content-info-li`]')
            div(:class='$style[`cc-binder-content-li-left`]')
              svg(fill="none" viewBox="0 0 24 24" height="24" width="24")
                circle(cx="12" cy="12" r="11.25" fill="#81e0a9")
                path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
            div(:class='$style[`cc-binder-content-li-right`]')
              div(:class='$style[`cc-binder-content-li-name`]') 學習所有抗癌衛教內容

        div(:class='$style[`cc-binder-content-control`]')
          button.btn-confirm-extra(
            v-if='bindType === `trail`'
            tabindex='0' aria-label='我同意開通'
            :class='$style[`cc-binder-content-control-btn`]'
            @click='debounceBindTrail') 
            span(style='color: white') 我同意

          button.btn-confirm-extra(
            v-else-if='bindType === `redeem`'
            tabindex='0' aria-label='我同意開通'
            :class='$style[`cc-binder-content-control-btn`]'
            @click='debounceBindRedeem') 
            span(style='color: white') 我同意

          button.btn-confirm-extra(
            v-else-if='bindType === `expense`'
            tabindex='0' aria-label='前往付費'
            :class='$style[`cc-binder-content-control-btn`]'
            @click='debounceBindExpense') 
            span(style='color: white') 前往付費

          div(:class='$style[`cc-binder-content-control-tips`]')
            != '使用癌症照護服務代表您同意 '
            router-link(title='使用條款' tabindex='0' aria-label='使用條款' to='/termUsage') 使用條款
            != ' 和 '
            router-link(title='隱私政策' tabindex='0' aria-label='隱私政策' to='/privacy') 隱私政策

        div(:class='$style[`cc-binder-content-precaution`]')
          span 繼續即表示您已閱讀並同意
          router-link(
            to='/termUsage'
            target='_blank'
            rel='noreferrer'
            tabindex='0'
            aria-label=' 隱私權政策'
            title="隱私權") 隱私權政策
          span!= ' - '
          router-link(
            to='/privacy'
            target='_blank'
            tabindex='0'
            aria-label='條款'
            rel='noreferrer'
            title="條款") 條款



</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import IconLoading from '../../icon/Loading';
import IconLine from '../../icon/Line';

import { debounce } from 'debounce';
import GlobalEmitter from 'tiny-emitter/instance';
// import axios from 'axios';
// import qs from 'qs';
// import { v4 as uuidv4 } from 'uuid';

import { 
  putLoadVendorBindProfile,
  postVendorBindTrail,
  putRedeemConvert,
  putRedeemValidCheck,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '開通訂閱照護',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: `https://cancell.tw/binder?b=${this.$route.query.b}`,
      }],
      link: [{
        rel: 'canonical',
        href: `https://cancell.tw/binder?b=${this.$route.query.b}`,
      }],
    };
  },

  components: {
    IconLoading,
    IconLine,
  },

  created() {
    if (this.$route.query.b) {
      console.log('Binder Query');
      const BIND_CONFIG = this.$route.query.b.split('-');

      this.bindTeamHash = BIND_CONFIG[0];
      this.bindMonth = BIND_CONFIG[1];
      this.bindType = BIND_CONFIG[2];

      // console.log('Binder', this.$route.query, this.bindConfig);
      if (this.bindType.match(/(trail|expense|redeem)/ig)) {
        // && this.bindShopType.match(/(subscribe|bundle|stuff)/ig)
        switch (this.bindType) {
          case 'expense':
            this.bindShopType = BIND_CONFIG[3];
            this.bindShopId = BIND_CONFIG[4];
            this.bindRedeemCode = '';
            this.handleLoadVendorProfile(this.bindTeamHash);
            break;

          case 'redeem':
            this.bindShopType = '';
            this.bindShopId = '';
            this.bindRedeemCode = BIND_CONFIG[3];
            this.handleRedeemCodeValidCheck(this.bindRedeemCode, this.bindMonth);
            break;

          case 'trail':
            this.handleLoadVendorProfile(this.bindTeamHash);
            break;
        
          default:
            break;
        }

      } else {
        this.bindError = true;
        this.showLoading = false;
      }
    } else {
      this.bindError = true;
      this.showLoading = false;
    }
  },

  data() {
    return {
      // memberType: '',
      showLoading: true,
      bindActive: false,
      needLogin: false,
      // bindConfig: [],
      bindError: false,
      bindCodeInvalid: false,

      bindType: '',
      bindMonth: 0,
      bindRedeemCode: '',
      bindTeamHash: '',

      bindShopType: '',
      bindShopId: '',

      createSideEffect: false,
      vendorProfile: {},
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClickLineAuthorize(user_type) {
      window.location = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${this.LINE_LOGIN_ID}&redirect_uri=${this.LINE_LOGIN_DOMAIN}/line/authorize&state=${user_type}&scope=openid%20profile&nonce=helloWorld&prompt=consent&ui_locales=zh-TW`;
    },

    handleRedeemCodeValidCheck(code, month) {
      putRedeemValidCheck('', {
        code, month,
      })
        .then((res) => {
          console.log('putLoadVendorBindProfile', res.data);
          if (res.data === 'valid') {
            this.handleLoadVendorProfile(this.bindTeamHash);
          } else {
            this.bindError = true;
            this.showLoading = false;
          }
        })
        .catch((err) => {
          this.bindError = true;
          this.bindCodeInvalid = true;
          this.showLoading = false;
        });
    },

    handleShowPopLogin() {
      this.changePopBoxStatus({
        active: true,
        include: 'login',
      });
    },

    handleLoadVendorProfile(teamHash) {
      putLoadVendorBindProfile('', {
        team_hash: teamHash,
        team_id: null,
      })
        .then((res) => {
          // const lineProfile = jwt_decode(`${data}`);
          console.log('putLoadVendorBindProfile', res.data);
          this.vendorProfile = res.data;

          if (!this.loginStatus) {
            this.changePopBoxStatus({
              active: true,
              include: 'login',
            });

            this.needLogin = true;
            this.showLoading = false;
            return;
          }

          if (this.loginProfile.sideeffect !== 'yes') {
            this.createSideEffect = true;
          } else {
            if (res.data.team_id === this.userSubscribeBindVendor) {
              this.bindActive = true;
            }
          }

          this.showLoading = false;
        })
        .catch((err) => {
          console.log('ERROR', err);
          this.bindError = true;
          this.showLoading = false;
        });
    },

    handleBindExpenseProcess() {
      if (this.bindShopType === 'subscribe') {
        this.$router.push({
          path: '/shop/subscribe',
          query: {
            shared: this.bindTeamHash,
            id: this.bindShopId,
          },
        }).catch(() => true);
      }
    },

    handleBindTrailProcess() {
      this.changePopBoxStatus({
        active: true,
        include: 'loading',
      });

      const BIND_CONFIG = {
        auth_id: this.loginDjangoId,
        team_hash: this.bindTeamHash,
        team_id: this.vendorProfile.team_id,
        month: this.bindMonth,
        purpose: this.bindType
      };

      console.log('BIND_CONFIG', BIND_CONFIG);

      postVendorBindTrail('', BIND_CONFIG)
        .then((res) => {
          console.log('postVendorBindTrail', res);

          if (res.data === 'error') {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });
            this.bindError = true;
            return;
          };
          
          this.changePopBoxStatus({
            active: true,
            include: 'sendBindConfirm',
          });
          
          this.$router.push('/sideeffect/consult').catch(() => true);
          
          setTimeout(() => {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });

            // 更新User Store State 成已訂閱
            GlobalEmitter.emit('force-root-update', {
              event: 'userProfile-refresh',
            });
          }, this.POP_DURATION);
        })
        .catch((err) => {
          this.changePopBoxStatus({
            active: false,
            include: '',
          });
          this.bindError = true;
        })
    },

    handleBindRedeemProcess() {
      this.changePopBoxStatus({
        active: true,
        include: 'loading',
      });

      const BIND_CONFIG = {
        auth_id: this.loginDjangoId,
        code: this.bindRedeemCode,
        team_id: this.vendorProfile.team_id,
        team_hash: this.bindTeamHash,
      };

      console.log('BIND_CONFIG', BIND_CONFIG);

      putRedeemConvert('', BIND_CONFIG)
        .then((res) => {
          console.log('putRedeemConvert', res);

          if (res.data === 'error') {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });
            this.bindError = true;
            return;
          };
          this.changePopBoxStatus({
            active: true,
            include: 'sendBindConfirm',
          });

          this.$router.push('/sideeffect/consult').catch(() => true);

          setTimeout(() => {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });

            // 更新User Store State 成已訂閱
            GlobalEmitter.emit('force-root-update', {
              event: 'userProfile-refresh',
            });
          }, this.POP_DURATION);
        })
        .catch((err) => {
          this.changePopBoxStatus({
            active: false,
            include: '',
          });
          this.bindError = true;
        })
    },

    debounceBindExpense: debounce(async function(e) {
      this.handleBindExpenseProcess(e);
    }, 300),

    debounceBindTrail: debounce(async function(e) {
      this.handleBindTrailProcess(e);
    }, 300),

    debounceBindRedeem: debounce(async function(e) {
      this.handleBindRedeemProcess(e);
    }, 300),
  },

   // eslint-disable-next-line vue/order-in-components
   computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      userSubscribeBindVendor: 'user/exportUserSubscribeBindVendor',
      // authJwtToken: 'user/exportUserJwtToken',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/member/binder.scss';
</style>
